export const colors = {
  "brand": {
    "primary": "#6C00F6",
    "primaryLight1": "#EBDDFF",
    "primaryLight2": "#B07CFF",
    "primaryDark1": "#4A00A8",
    "primaryDark2": "#2D0066",
    "secondary": "#A1F919",
    "secondaryLight1": "#EEFFC9",
    "secondaryLight2": "#EEFFC9",
    "secondaryDark1": "#6EA90F",
    "secondaryDark2": "#6EA90F",
    "tertiary": "#00B8FF",
    "tertiaryLight1": "#EBDDFF",
    "tertiaryLight2": "#EBDDFF",
    "tertiaryDark1": "#6C00F6",
    "tertiaryDark2": "#4A00A8"
  },
  "neutral": {
    "white": "#FFFFFF",
    "lightest": "#EEEEEE",
    "lighter": "#CCCCCC",
    "light": "#AAAAAA",
    "base": "#666666",
    "dark": "#444444",
    "darker": "#222222",
    "darkest": "#000000"
  },
  "text": {
    "title": "#222222",
    "primary": "#222222",
    "secondary": "#444444",
    "muted": "#666666",
    "disabled": "#AAAAAA"
  },
  "background": {
    "main": "#FFFFFF",
    "secondary": "#EEEEEE",
    "branded": "#6C00F6"
  },
  "border": {
    "default": "#EEEEEE",
    "dark": "rgba(0, 0, 0, 0.15)"
  },
  "button": {
    "primary": "#6C00F6",
    "primaryHover": "#4A00A8",
    "secondary": "#FFFFFF"
  },
  "link": "#6C00F6",
  "status": {
    "success": "#34C759",
    "error": "#FF3B30",
    "warning": "#FF9500",
    "info": "#007AFF"
  },
  "opacity": {
    "white5": "rgba(255, 255, 255, 0.05)",
    "white10": "rgba(255, 255, 255, 0.10)",
    "white15": "rgba(255, 255, 255, 0.15)",
    "white20": "rgba(255, 255, 255, 0.20)",
    "white30": "rgba(255, 255, 255, 0.30)",
    "white40": "rgba(255, 255, 255, 0.40)",
    "white50": "rgba(255, 255, 255, 0.50)",
    "white60": "rgba(255, 255, 255, 0.60)",
    "black5": "rgba(0, 0, 0, 0.05)",
    "black10": "rgba(0, 0, 0, 0.10)",
    "black15": "rgba(0, 0, 0, 0.15)",
    "black20": "rgba(0, 0, 0, 0.20)",
    "black30": "rgba(0, 0, 0, 0.30)",
    "black40": "rgba(0, 0, 0, 0.40)",
    "black50": "rgba(0, 0, 0, 0.50)",
    "black60": "rgba(0, 0, 0, 0.60)"
  }
} as const;

export const fontFamily = {
  "heading": "'Satoshi', sans-serif",
  "body": "'Inter', sans-serif"
} as const;
